import styled from '@emotion/styled'
import { makeGroupOrderTimeStr } from '@open-tender/utils'
import {
  openModal,
  selectGroupOrder,
  selectGroupOrderPrepTimes,
  selectOrder,
  selectTimezone,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { Body, ButtonLink } from 'components'

const GroupOrderTimeView = styled.div`
  & > p + p {
    margin: 1.5rem 0 0;
    font-size: ${(props) => props.theme.fonts.sizes.small};
  }
`

const GroupOrderTime = () => {
  const dispatch = useAppDispatch()
  const { requestedAt, revenueCenter, serviceType, orderType } =
    useAppSelector(selectOrder)
  const tz = useAppSelector(selectTimezone)
  const { order_times } = revenueCenter || {}
  const orderTimes = order_times ? order_times[serviceType ?? 'WALKIN'] : null
  const { cutoffAt } = useAppSelector(selectGroupOrder)
  const orderTime = makeGroupOrderTimeStr(requestedAt, tz)
  const cutoffTime = makeGroupOrderTimeStr(cutoffAt, tz)
  const { prepTime } = useAppSelector(selectGroupOrderPrepTimes)
  const args = {
    focusFirst: true,
    skipClose: true,
    style: orderTimes ? { alignItems: 'flex-start' } : {},
    revenueCenter,
    serviceType,
    orderType,
    requestedAt,
  }

  const adjustTime = () => {
    dispatch(openModal({ type: 'requestedAt', args }))
  }

  return (
    <GroupOrderTimeView>
      <Body as="p">
        {orderTime === 'ASAP'
          ? `Please note that this group order is currently scheduled for ASAP and will be ready about ${prepTime} minutes from the time it gets submitted.`
          : `Please note that this order must be submitted by ${cutoffTime} in order to
      be ready by the scheduled time of ${orderTime}.`}{' '}
      </Body>
      <Body as="p">
        <ButtonLink onClick={adjustTime}>Choose a different time</ButtonLink>
      </Body>
    </GroupOrderTimeView>
  )
}

export default GroupOrderTime
